import React, { useEffect, useState } from 'react';
import { 
    Route,
    BrowserRouter as Router,
    Redirect,
    withRouter
} from 'react-router-dom';

import Login from './pages/login';
import Home from './pages/home';
import Config from './pages/configuracoes';
import FormasDePagamento from './pages/formasDePagamento';
import Horarios from './pages/horarios';
import NovaSenha from './pages/login/nova-senha';
import TrocarSenha from './pages/trocar-senha';
import SuperUser from './pages/super-user';
import Restaurante from './pages/meu-restaurante';
import TempoEntrega from './pages/tempo-entrega';
import Produtos from './pages/produtos';
import Promocoes from './pages/promocoes';
import Financeiro from './pages/financeiro';
import Ajuda from './pages/ajuda';
import Avaliacoes from './pages/aval';
import MeuContrato from './pages/meucontrato';
import Relatorio from './pages/relatorio';
import RelatorioVendas from './pages/relatorioVendas';



import HeaderMob from './components/HeaderMob';
import Header from './components/Header';
import Nav from './components/Nav';
import FooterNav from './components/FooterNav';

import api from './services/api';
import moment from 'moment';

    const LeftNav = withRouter(Nav);
    const BottomNav = withRouter(FooterNav);
    const HeaderMobile = withRouter(HeaderMob);
    const HeaderDesktop = withRouter(Header);

    const Auth = () => {
        const token = localStorage.getItem('@jwt');
        const ttl = localStorage.getItem('@ttl');
        const unix = moment().unix();
    
        if(token && (unix < ttl)) {
            return true
        } else {
            return false
        }
    }

    const CheckSuperUser = () => {
        const rest = localStorage.getItem('@internal');
        const auth = Auth();
    
        if(rest && auth === true) {
            return true
        } else {
            return false
        }
    }

    const Navigator = withRouter(({location, history}) => {

        const [isOpen, setOpen] = useState(false);
        const [status, setStatus] = useState(false);
        const [counter, setCounter] = useState(0);

        useEffect(() => {
                timechecker();
                history.listen(async(location, action) => {
                    await timechecker();
                })
        }, [])

        // async function checker() {
        //     const ttl = await localStorage.getItem('@ttl');
        //     const unix = await moment().unix();

        //     if (unix < ttl) {
        //         return console.log('válido');
        //     } else {
        //         console.log('inválido');
        //         return <Redirect to="/login"/>;
        //     }
        // }

        const timechecker = async () => {
            const token = await localStorage.getItem('@jwt');
            const uf = await localStorage.getItem('@uf');
            if ((token && uf) !== null) {
                try {
                    const aberto = await api.get(`api/timechecker/${uf}`, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    setStatus(aberto.data.message);
                } catch (e) {
                    console.log(e.data);
                }
            }
            setCounter(prevCount => prevCount + 1);
        }

        const controllerModal = (state) => {
            setOpen(!state)
        }

        const controllerStatus = (state) => {
            setStatus(!state)
        }
        
        return(<>
            <LeftNav />
            <HeaderDesktop
                status={status}
                changeStatus={() => controllerStatus(status)}
                modalOpen={isOpen}
                closeModal={() => controllerModal(isOpen)} />
            <HeaderMobile
                status={status}
                changeStatus={() => controllerStatus(status)}
                modalOpen={isOpen}
                closeModal={() => controllerModal(isOpen)} />
            <BottomNav />
        </>)
    })

    export const Routes = () => (
        <Router>
            <Main />
        </Router>
    )

    const Main = withRouter(({location, history}) => {

        return(
            <>
                {location.pathname !== '/login' && location.pathname !== '/super-user' && location.pathname !== '/a' ? <Navigator /> : null}
                <Route path="/login" exact> 
                    {Auth() ? <Redirect to='/configuracoes' /> : <Login />}
                </Route>
                <Route path="/" exact> 
                    {Auth() ? <Redirect to="/configuracoes" /> : <Login />}
                </Route>
                <PrivateRoute component={Home} path="/" exact />
                <PrivateRoute component={Config} path="/configuracoes" exact />
                <PrivateRoute component={Relatorio} path="/minhas-vendas" exact />
                <PrivateRoute component={RelatorioVendas} path="/minhas-vendas/detalhes/:chave_pedido" exact />
                <PrivateRoute component={Produtos} path="/produtos" exact />
                <PrivateRoute component={Promocoes} path="/promocoes" exact />
                <PrivateRoute component={Financeiro} path="/financeiro" exact/>
                <PrivateRoute component={Ajuda} path="/ajuda" exact />
                <PrivateRoute component={MeuContrato} path="/ajuda/meucontrato" exact />
                <PrivateRoute component={Avaliacoes} path="/avaliacoes" exact />
                <PrivateRoute component={Restaurante} path="/configuracoes/meu-restaurante" exact />
                <PrivateRoute component={TempoEntrega} path="/configuracoes/entrega" exact />
                <PrivateRoute component={FormasDePagamento} path="/configuracoes/formas-de-pagamento" />
                <PrivateRoute component={Horarios} path="/configuracoes/horarios-de-funcionamento" />
                <PrivateRoute component={TrocarSenha} path="/novaSenha" />
                <SuperRoute component={SuperUser} path="/super-user" />
                <Route component={NovaSenha} path="/a" />
            </>
        )
    });

    const PrivateRoute = ({ component: Component, ...rest }) => (
        <Route {...rest} render={props => (
            Auth() ? (
                <Component {...props} />
            ) : (
                <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            )
        )}
        />
    )
    
    const SuperRoute = ({ component: Component, ...rest }) => (
        <Route {...rest} render={props => (
            CheckSuperUser() ? (
                <Component {...props} />
            ) : (
                <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            )
        )}
        />
    )